var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    {
      staticClass: "d-flex flex-column",
      attrs: { id: "annonce-create-container" }
    },
    [
      _c(
        "div",
        {
          staticClass: "row pt-md-3 pt-2",
          attrs: { id: "annonce-create-title-container" }
        },
        [
          _c(
            "div",
            { staticClass: "col-12 col-md-6 d-flex justify-content-center" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "custom-width ml-md-5 justify-content-between d-md-flex align-items-center"
                },
                [
                  _c("back-arrow", {
                    attrs: {
                      confirm: _vm.currentStep > _vm.getStepIndex("ONBOARDING"),
                      title: _vm.$t("annonce.Create"),
                      "title-modal": _vm.$t("annonce.leave.page.ask")
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.currentStep > _vm.getStepIndex("VEHICLE_TYPE") &&
          _vm.currentStep < _vm.getStepIndex("RECAP") &&
          this.annonce.status !== "TO_VALIDATE"
            ? _c(
                "div",
                { staticClass: "col-12 col-md-6 d-flex justify-content-start" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-100 d-md-flex align-items-center justify-content-center d-none"
                    },
                    [
                      !_vm.saved && !_vm.notSaved
                        ? _c("i", {
                            staticClass:
                              "ph-custom ph-floppy-disk cursor-pointer d-none d-md-block",
                            on: { click: _vm.saveDraft }
                          })
                        : _vm.saved
                        ? _c("i", {
                            staticClass:
                              "ph-custom ph-check d-none d-md-block main-green-color"
                          })
                        : _vm.notSaved
                        ? _c("i", {
                            staticClass:
                              "ph-custom ph-warning d-none d-md-block main-red-color"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "pl-2",
                          class: {
                            "main-green-color": _vm.saved,
                            "main-red-color": _vm.notSaved,
                            "cursor-pointer": !_vm.saved && !_vm.notSaved
                          },
                          on: { click: _vm.saveDraft }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.saved
                                ? _vm.$t("annonce.saved.Draft")
                                : _vm.notSaved
                                ? _vm.$t("annonce.notSaved.Draft")
                                : _vm.$t("annonce.save.Draft")
                            )
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.getStepCondition("ONBOARDING")
        ? _c("annonce-create-step0", { on: { setMaxStep: _vm.setMaxStep } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep > _vm.getStepIndex("ONBOARDING")
        ? _c(
            "div",
            {
              staticClass: "row pt-md-5 pt-2",
              attrs: { id: "annonce-create-sub-container" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-12 col-md-6 col-title",
                  attrs: { id: "annonce-create-sub-container-left" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "custom-width ml-md-5 d-flex align-items-center"
                    },
                    [
                      _vm.getStepCondition("RECAP")
                        ? _c("h1", { staticClass: "page-title w-75" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("annonce.recap.annonce.title"))
                            )
                          ])
                        : _vm.getStepCondition("ADDITIONNAL_REWARD")
                        ? _c("h1", { staticClass: "page-title w-75" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "annonce.create.additional.reward.page.title"
                                  )
                                )
                            )
                          ])
                        : _vm.getStepCondition("PAYMENT_SUMMARY")
                        ? _c("h1", { staticClass: "page-title w-75" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("payment.summary.page.title"))
                            )
                          ])
                        : _c("h1", { staticClass: "page-title w-75" }, [
                            _vm._v(_vm._s(_vm.$t("annonce.Declare")))
                          ]),
                      _vm._v(" "),
                      _vm.currentStep < _vm.getStepIndex("RECAP") &&
                      !_vm.saved &&
                      !_vm.notSaved &&
                      this.annonce.status !== "TO_VALIDATE"
                        ? _c("i", {
                            staticClass:
                              "ph-custom ph-floppy-disk cursor ml-auto save-draft-icon-mobile d-block d-md-none",
                            on: { click: _vm.saveDraft }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep < _vm.getStepIndex("RECAP") && _vm.saved
                        ? _c("i", {
                            staticClass:
                              "ph-custom ph-floppy-disk cursor ml-auto save-draft-icon-mobile d-block d-md-none main-green-color"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep < _vm.getStepIndex("RECAP") &&
                      _vm.notSaved
                        ? _c("i", {
                            staticClass:
                              "ph-custom ph-warning-diamond cursor ml-auto save-draft-icon-mobile d-block d-md-none main-red-color"
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.getStepCondition("VEHICLE_TYPE")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c("h1", { staticClass: "content" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("annonce.typeof.vehicle"))
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("BRAND")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c("h1", { staticClass: "content" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("annonce.typeof.brand"))
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("MODEL")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c("h1", { staticClass: "content" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("annonce.typeof.model"))
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("MANDATORY_FIELDS")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c("h1", { staticClass: "content" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("annonce.vehicle.more.informations")
                              )
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("ADDITIONNAL_FIELDS")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c("h1", { staticClass: "content" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("annonce.vehicle.more.informations")
                              )
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("PHOTOS")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c("h1", { staticClass: "content" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("annonce.vehicle.more.images"))
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("PAPERS")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c("h1", { staticClass: "content" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t(
                                  "annonce.vehicle.more.informations.identity"
                                )
                              )
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("ADDITIONNAL_REWARD")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c("span", { staticClass: "bold-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("annonce.create.additional.reward.title")
                            )
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("ADDITIONNAL_REWARD")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c("h1", { staticClass: "content" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "annonce.create.additional.reward.description"
                              )
                            )
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("ADDITIONNAL_REWARD")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c(
                          "p",
                          {
                            staticClass: "link-main-color cursor-pointer",
                            on: {
                              click: function($event) {
                                return _vm.$bvModal.show(
                                  "additional-reward-info-modal"
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "annonce.create.additional.reward.know.more"
                                  )
                                )
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("RECAP")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c("h1", { staticClass: "content" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("annonce.Recap.annonce.subtitle"))
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("RECAP")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c("span", { staticClass: "bold-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("annonce.Recap.annonce.tip.Add"))
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("PAYMENT_SUMMARY")
                    ? _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                        _c("h1", { staticClass: "content" }, [
                          _vm._v(
                            _vm._s(_vm.$t("payment.summary.page.description"))
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("PAYMENT_SUMMARY")
                    ? _c("PaymentSummaryTotalCard", {
                        staticClass: "custom-width ml-md-5 mt-3",
                        attrs: { annonces: _vm.annonces },
                        on: { setTotalToPay: _vm.setTotalToPay }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-md-6 d-flex justify-content-center justify-content-md-start",
                  attrs: { id: "annonce-create-sub-container-right" }
                },
                [
                  _vm.getStepCondition("VEHICLE_TYPE")
                    ? _c("annonce-create-step1", {
                        attrs: { annonce: this.annonce },
                        on: { updateAnnonce: _vm.updateAnnonce }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("BRAND")
                    ? _c("annonce-create-step2", {
                        attrs: { annonce: this.annonce },
                        on: { updateAnnonce: _vm.updateAnnonce }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("MODEL")
                    ? _c("annonce-create-step3", {
                        attrs: { annonce: this.annonce },
                        on: { updateAnnonce: _vm.updateAnnonce }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("MANDATORY_FIELDS")
                    ? _c("annonce-create-step4", {
                        attrs: {
                          annonce: this.annonce,
                          hasBicycode: _vm.hasBicycode,
                          hasSerialNumber: _vm.hasSerialNumber,
                          hasVIN: _vm.hasVIN,
                          isLicensed: _vm.isLicensed
                        },
                        on: { updateAnnonce: _vm.updateAnnonce }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("ADDITIONNAL_FIELDS")
                    ? _c("annonce-create-step5", {
                        attrs: {
                          annonce: this.annonce,
                          "has-window-engraving-vehicle-type":
                            _vm.hasWindowEngraving,
                          hasVIN: _vm.hasVIN,
                          isLicensed: _vm.isLicensed
                        },
                        on: { updateAnnonce: _vm.updateAnnonce }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("PHOTOS")
                    ? _c("annonce-create-step6", {
                        attrs: { annonce: this.annonce },
                        on: { updateAnnonce: _vm.updateAnnonce }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("PAPERS")
                    ? _c("annonce-create-step7", {
                        attrs: {
                          annonce: this.annonce,
                          isLicensed: _vm.isLicensed
                        },
                        on: { updateAnnonce: _vm.updateAnnonce }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("ADDITIONNAL_REWARD")
                    ? _c("annonce-create-additional-reward-step", {
                        attrs: {
                          annonce: this.annonce,
                          fromAnnonceCreation: true
                        },
                        on: { updateAnnonce: _vm.updateAnnonce }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("RECAP")
                    ? _c("annonce-create-recap-step", {
                        attrs: {
                          annonces: this.annonces,
                          "annonces-saved": this.annoncesSaved
                        },
                        on: {
                          addDraft: _vm.addDraft,
                          addNewAnnonce: _vm.addNewAnnonce,
                          editAnnonce: _vm.editAnnonce,
                          removeAnnonce: _vm.removeAnnonce
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getStepCondition("PAYMENT_SUMMARY")
                    ? _c("AnnonceCreatePaymentSummaryStep", {
                        attrs: { annonces: this.annonces }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep > _vm.getStepIndex("ONBOARDING")
        ? _c(
            "div",
            { staticClass: "footer-create-annonce" },
            [
              _c(
                "span",
                {
                  staticClass: "fixed-bottom-100px span-step d-none d-md-block"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("register.Step") +
                        " " +
                        _vm.currentStep +
                        "/" +
                        _vm.maxStep
                    )
                  )
                ]
              ),
              _vm._v(" "),
              _c("b-progress", {
                staticClass: "custom-progress-bar-no-radius",
                attrs: {
                  max: _vm.maxStep,
                  value: _vm.currentStep,
                  height: "1em",
                  variant: "primary"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row h-100" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-12 d-flex align-items-center mb-2 ml-2 mr-2 justify-content-around"
                  },
                  [
                    !_vm.hasValidatedPublishing
                      ? _c(
                          "b-button",
                          {
                            ref: "btnPrevStep",
                            staticClass: "mr-1",
                            attrs: {
                              disabled:
                                _vm.getStepCondition("RECAP") ||
                                (_vm.getStepCondition("MANDATORY_FIELDS") &&
                                  this.lockPreviousButton),
                              variant: "secondary"
                            },
                            on: { click: _vm.prevStep }
                          },
                          [
                            _c("div", { staticClass: "pr-3 pl-3" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.currentStep >
                                    _vm.getStepIndex("VEHICLE_TYPE")
                                    ? _vm.$t("Previous")
                                    : _vm.$t("Back")
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "span-step d-block d-md-none" }, [
                      _vm._v(_vm._s(_vm.currentStep + " / " + _vm.maxStep))
                    ]),
                    _vm._v(" "),
                    _vm.currentStep > _vm.getStepIndex("MANDATORY_FIELDS") &&
                    _vm.currentStep < _vm.getStepIndex("RECAP")
                      ? _c("div", { staticClass: "custom-span-data" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("annonce.enough.data"))
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.hasValidatedPublishing
                      ? _c(
                          "b-button",
                          {
                            ref: "btnNextStep",
                            staticClass: "mr-1",
                            attrs: {
                              disabled:
                                _vm.getStepCondition("RECAP") &&
                                _vm.annonces.length === 0,
                              variant: "primary"
                            },
                            on: { click: _vm.nextStep }
                          },
                          [
                            !_vm.isPublishing && !_vm.isLoading
                              ? _c("div", { staticClass: "pr-4 pl-4" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.buttonTitlePublishOrNext
                                          ? _vm.$t("Publish")
                                          : _vm.$t("Next")
                                      ) +
                                      "\n          "
                                  )
                                ])
                              : _c("b-spinner", {
                                  staticClass: "button-spinner"
                                })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("annonce-incomplete-modal", {
        attrs: { annonce: _vm.annonce },
        on: {
          checkedNotif: _vm.updateAnnonce,
          complete: _vm.handleCompleteIncompleteAnnonce,
          publish: _vm.publishIncompleteAnnonce
        }
      }),
      _vm._v(" "),
      _c("annonce-online-modal", { attrs: { annonces: _vm.annonces } }),
      _vm._v(" "),
      _c("annonce-pro-modal", { on: { okProModal: _vm.okProModal } }),
      _vm._v(" "),
      _c("AnnoncePaymentPromiseModal", {
        on: { close: _vm.closedPaymentModal, publish: _vm.handlePaymentSuccess }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f36750d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f36750d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceCreate/AnnonceCreate.vue
// module id = thQR
// module chunks = 0